import { makeAutoObservable } from 'mobx';
import { DashboardApi } from '../../apis/Dashboard';
import { SalesOverview } from '../../models/Dashboard';

export class DashboardPageModel {
    salesOverview: SalesOverview | null = null;
    historyData: SalesOverview[] = [];
    loading: boolean = false;
    selectedMonth: string = new Date().toISOString().slice(0, 7); // 默认当前月份 YYYY-MM

    constructor() {
        makeAutoObservable(this);
    }

    setSelectedMonth(month: string) {
        this.selectedMonth = month;
        this.fetchOverview(); // 自动触发查询
    }

    async fetchOverview() {
        this.loading = true;
        try {
            this.salesOverview = await DashboardApi.getOverview({
                monthTime: new Date(this.selectedMonth + '-01')
            });
        } catch (error) {
            console.error('获取销售概览数据失败:', error);
        } finally {
            this.loading = false;
        }
    }

    async fetchHistory() {
        try {
            this.historyData = await DashboardApi.getOverviewHistory({
                months: 6 // 获取最近6个月的数据
            });
        } catch (error) {
            console.error('获取历史数据失败:', error);
        }
    }
} 